import React from "react";
import ChapterBlock from "./ChapterBlock";

function ChapterHeader({ chapter }) {
  return (
    <header className="mb-10">
      <div className="eyebrow mb-3">Chapter</div>
      <h2 className="font-display uppercase font-bold text-4xl md:text-6xl leading-[0.92] tracking-tight">
        {chapter.title}
      </h2>
      {chapter.subtitle && (
        <p className="mt-4 font-serif-display italic text-xl md:text-2xl opacity-80">
          {chapter.subtitle}
        </p>
      )}
      <div className="thick-rule mt-8" />
      {chapter.image && (
        <figure
          className="mt-8 border-2 border-current overflow-hidden"
          data-testid={`chapter-image-${chapter.id}`}
        >
          <img
            src={chapter.image}
            alt={chapter.imageCaption || chapter.title}
            className="w-full max-h-[480px] object-cover duotone"
            loading="lazy"
          />
          {chapter.imageCaption && (
            <figcaption className="border-t-2 border-current px-3 py-2 font-display uppercase tracking-widest text-[0.65rem] opacity-80">
              {chapter.imageCaption}
            </figcaption>
          )}
        </figure>
      )}
    </header>
  );
}

export default function ChapterBody({ chapter }) {
  return (
    <article
      id={chapter.id}
      data-testid={`chapter-${chapter.id}`}
      className="scroll-mt-24 mb-24"
    >
      <ChapterHeader chapter={chapter} />
      <div className="space-y-7 max-w-[64ch]">
        {chapter.blocks.map((block, i) => (
          // Book content is static JSON: chapterId + position is a stable key.
          <ChapterBlock
            key={`${chapter.id}-${i}`}
            block={block}
            isFirst={i === 0}
          />
        ))}
      </div>
    </article>
  );
}
